import Typography from '@mui/material/Typography'
import { useSelector } from 'react-redux'
import Grid from '@mui/material/Grid'
import { Theme, useTheme, useMediaQuery } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import GameOptions from '../ui/GameOptions'
import { FormattedMessage } from 'react-intl'
import { GameFormats } from '../../../utils/enums'
import RankingConfig from './RankingConfig'
import TourCondensedInfo from './TourCondensedInfo'
import ContestInfo from './ContestInfo'
import { rem } from '@app/theme/materialUITheme'

const useStyles = makeStyles((theme: Theme) => ({
  subtitle: {
    fontStyle: 'normal',
    color: theme.customPalette.siteNavigationText,
  },
  contentContainer: {
    width: 250,
    [theme.breakpoints.down('md')]: {
      maxWidth: '100%',
      width: '100%',
    },
  },
  contestContainer: {
    [theme.breakpoints.down('sm')]: {
      width: '100%',
    },
  },
  gameDetailsTitle: {
    [theme.breakpoints.down('md')]: {
      marginTop: 0,
    },
  },
  primaryGameTitle: {
    color: theme.customPalette.siteNavigationText,
    fontStyle: 'normal',
  },
  gameTitle: {
    width: 250,
  },
}))

interface Props {
  round: number
}

const GameInfo = ({ round }: Props) => {
  const theme = useTheme()
  const mediaQuery = useMediaQuery(theme.breakpoints.down('sm'))
  const classes = useStyles()

  const tournamentSite = useSelector((state: StoreState) => state.tournamentReducer.tournamentSite)
  const roundData = tournamentSite.tournament.rounds[round]

  if (!roundData) {
    return null
  }

  const firstRound = tournamentSite.tournament.rounds[0]

  const justifyContent = mediaQuery ? 'flex-start' : 'center'
  const sideGame = roundData.sideGameEnabled && roundData.sideGame.id !== GameFormats.NO_SIDE
  // TODO: adapt to multiround?
  return (
    <Grid container rowSpacing={{ xs: 2, md: 3 }} columnGap={1}>
      <Grid container item xs={12} justifyContent={justifyContent} className={classes.gameDetailsTitle}>
        <Typography variant={'h2'}>
          <FormattedMessage id={'strings.gameDetails'} />
        </Typography>
      </Grid>

      <Grid item xs sx={{ display: 'flex', flexDirection: 'column', gap: rem(12) }}>
        <div className={classes.gameTitle}>
          <Typography variant="h4" className={classes.primaryGameTitle}>
            <FormattedMessage id={'strings.primaryGame'} />
          </Typography>
        </div>

        <GameOptions
          gameOptions={roundData.primaryGameOptions}
          gameFormatId={roundData.primaryGame.id}
          sideGameEnabled={sideGame}
        />
      </Grid>

      {sideGame && (
        <Grid item xs sx={{ display: 'flex', flexDirection: 'column', gap: rem(12) }}>
          <div className={classes.gameTitle}>
            <Typography variant="h4" className={classes.subtitle}>
              <FormattedMessage id={'strings.sideGame'} />
            </Typography>
          </div>
          <GameOptions gameOptions={roundData.sideGameOptions} gameFormatId={roundData.sideGame.id} />
        </Grid>
      )}

      <ContestInfo round={round} />

      <TourCondensedInfo />

      <RankingConfig round={firstRound} />
    </Grid>
  )
}

export default GameInfo
